import { ExportPointsTransactionsRequest } from '@aslanpay/portal-common-lib';

import { RewardHistoryTableData } from './types';

// Prefix for the placeholder group id given to transactions without a transactionGroupId.
// It is not a real group id, so it must never be sent to the export as one.
export const UNGROUPED_GROUP_ID_PREFIX = 'ungrouped_';

const EXPORT_SIZE = 50000;

export const buildGiftingExportParams = ({
  groupId,
  recipients,
  transactionIds,
}: RewardHistoryTableData): ExportPointsTransactionsRequest => {
  const isRealGroup = !groupId.startsWith(UNGROUPED_GROUP_ID_PREFIX);

  if (isRealGroup && recipients > 1) {
    return { transactionGroupIds: [groupId], size: EXPORT_SIZE };
  }

  return { ids: transactionIds, size: EXPORT_SIZE };
};
